"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const analytics_1 = require("@completeanatomy/analytics");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../../hooks");
const Route_1 = require("../../router/Route");
const AuthProcess_1 = require("../../types/AuthProcess");
function SignInButton() {
    const auth = (0, hooks_1.useAuth)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const analytics = (0, analytics_1.useAnalytics)();
    const onClick = () => {
        auth === null || auth === void 0 ? void 0 : auth.authenticate();
        analytics.log('SignInPressed');
        // @ts-ignore
        window.navigateBack = true;
        navigate(`${Route_1.Route.Base}/${Route_1.Route.InterimScreen}/${Route_1.Route.InterimScreenOpen}`, {
            state: {
                process: AuthProcess_1.AuthProcess.SignIn,
            },
        });
    };
    return ((0, jsx_runtime_1.jsx)(StylesPrimaryButton, { onClick: onClick, "data-e2e": 'SignInButton_StylesPrimaryButton', children: (0, i18n_1.Localized)(i18n_1.Strings.auth.signIn) }));
}
exports.SignInButton = SignInButton;
const StylesPrimaryButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  text-transform: uppercase;
  padding: 7px 9px;
  margin: 0;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  border-radius: 6px;

  ${ui_1.device.laptopS `
    min-width: 156px;
    padding: 8px 16px;
    line-height: 24px;
  `}
`;
